import { useEffect, useMemo } from 'react';
import { WellnessFormDto } from '@repo/shared/dtos/analytics/WellnessDto';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { useWellnessForms } from './useWellnessAnalytics';
import { useWellnessFormId } from './useWellnessFormId';

const EMPTY_FORMS: WellnessFormDto[] = [];

export const getFormName = (form: WellnessFormDto) => form.name ?? `Form ${form.formid}`;

export function useSelectedWellnessForm(filters?: WellnessFilter) {
  const { data, isSuccess, isError } = useWellnessForms(filters);
  const [formId, setFormId] = useWellnessFormId();
  const forms = data ?? EMPTY_FORMS;

  const selected = useMemo(
    () =>
      forms.find(form => form.formid === formId) ??
      forms.find(form => form.isdefault) ??
      forms[0] ??
      null,
    [forms, formId],
  );

  let apiFormId: number | undefined = formId;
  if (isError) {
    apiFormId = undefined;
  } else if (isSuccess) {
    apiFormId = selected && !selected.isdefault ? selected.formid : undefined;
  }

  return { forms, selected, formId, setFormId, apiFormId, isSuccess, isError };
}

export function useWellnessFormFilter(filters?: WellnessFilter): number | undefined {
  const { forms, formId, setFormId, apiFormId, isSuccess, isError } =
    useSelectedWellnessForm(filters);

  useEffect(() => {
    if (formId === undefined) return;
    const match = forms.find(form => form.formid === formId);
    if (isError || (isSuccess && (!match || match.isdefault))) {
      setFormId(undefined);
    }
  }, [isError, isSuccess, forms, formId, setFormId]);

  return apiFormId;
}
